import { Injector } from '@angular/core';

export class AppInjector {
  public static injector: Injector;
}
